import { makeVariant } from '../../../types/makeVariant'

export const messages = makeVariant({
  primary: {
    fontSize: 1,
  },
})
